import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import { useCallback } from 'react'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { useNavigate, useLocation } from 'react-router'
import { getBasePath } from '../../../../../../../utils/globals/link'

interface ModalDeleteShippingCompanyProps extends ModalEditComponentProps { }

const ModalDeleteShippingCompany: React.FC<ModalDeleteShippingCompanyProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const {handleOnSubmit} = useModalDeleteShippingCompany({onSubmit})
    const { handleFetchText } = useFetchText({
        onSubmit: handleOnSubmit,
        url: '/api/app/config/shipping/shippingCompany/deleteShippingCompany',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteShippingCompany', '¿Seguro quieres eliminar este transportista?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

interface ModalDeleteShippingCompanyLogicProps {
    onSubmit: OnSubmit
}

const useModalDeleteShippingCompany = ({onSubmit}: ModalDeleteShippingCompanyLogicProps) => {
    const navigate = useNavigate();
    const location = useLocation().pathname

    const handleOnSubmit: OnSubmit = useCallback((res, valuesSend) => {
        onSubmit(res, valuesSend)
        navigate(getBasePath(location, 'shippingCompanies') + '/main')
    }, [onSubmit, location, navigate])

    return {handleOnSubmit}
}


export default ModalDeleteShippingCompany